import PrimaryButton from '../../../../../common/primary-button/primary-button';
import React, { useEffect, useState } from 'react';
import ServerSideService from '../../../../../../services/server-side-service/server-side-service';
import { Article } from '../../../../../../models/experiencefragments/category-view';
import './quiet-card.scss';
import { NewAnalyticsService } from '../../../../../../services/new-analytics-service/new-analytics-service';
import { CategoryOnClickCtaInfo } from '../../../../../../services/shortcode-service/shortcode-service';
import { useAnalytics } from '../../../../../../hooks/use-analytics';

interface QuietCardProps {
    article: Article;
    categoryType?: string;
    categoryPath?: string;
    title?: React.ReactNode;
    dictionaryOrResourcesAnalyticsText?: string;
    clickedCardText?: string;
}
export const QuietCard = (props: QuietCardProps) => {
    const categoryOnClickCtaInfo: CategoryOnClickCtaInfo = {
        ctaName: props.article.ctaLabel,
        categoryType: props.article.categoryType,
        categoryPath: props.article.categoryPath,
        ctaUrl: props.article.ctaPath,

    };

    const [isMobile, setMobile] = useState<boolean>(
        ServerSideService.isClientSide()
            ? window.matchMedia('(max-width: 500px)').matches
            : false
    );
    const handleWindowResize = () => {
        setMobile(
            ServerSideService.isClientSide()
                ? window.matchMedia('(max-width: 500px)').matches
                : false
        );
    };
    const [fireEvents] = useAnalytics();
    const eventClick = async () => {
        if(props.dictionaryOrResourcesAnalyticsText && props.clickedCardText){
            if(props.dictionaryOrResourcesAnalyticsText === 'dictionary'){
                fireEvents('towing-dictionary-footer-onclick-cta', undefined, {topicName: props.clickedCardText}, false)
            }
            else{
                fireEvents('towing-resources-footer-onclick-cta', undefined, {topicName: props.clickedCardText}, false)
            }
        }

        if (
            props.article.categoryType == 'category' ||
            props.article.categoryType == 'subcategory'
        ) {
            const referralExit = await new NewAnalyticsService().findMatchingReferralExit(
                props.article.ctaPath
            );
            if (referralExit) {
                NewAnalyticsService.fireReferralExitsEvent(
                    fireEvents,
                    referralExit
                );
            } else {
                fireEvents('category-onclick-event', undefined, {
                    categoryOnClickCtaInfo,
                });
            }
        }
    };

    useEffect(() => {
        window.addEventListener('resize', handleWindowResize);
        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);
    return (
        <div className="quiet-card">
            <img
                className="quiet-card__image"
                src={`${process.env.REACT_APP_AEM_BASE_URL}${
                    isMobile
                        ? props.article.mobileImagePath
                        : props.article.desktopImagePath
                }`}
                alt={props.article.plainTitle ?? ''}
            />
            <h3 className="quiet-card__title">{props.article.title}</h3>
            {props.article.description && (
                <p className="quiet-card__description">{props.article.description}</p>
            )}
            {props.article.ctaLabel && (
                <div className="quiet-card__button-wrapper">
                    <PrimaryButton
                        chevron={true}
                        color="dark"
                        fill="fill"
                        className="quiet-card__primary-button"
                        ariaLabel={props.article.ctaAriaLabel}
                        href={props.article.ctaPath}
                        target={props.article.targetBlank ? '_blank' : ''}
                        onClick={eventClick}
                    >
                        {props.article.ctaLabel}
                    </PrimaryButton>
                </div>
            )}
        </div>
    );
};
